module.exports = __webpack_public_path__ + "media/images/icon-benefits-dental-87f972712f0eb066c27808994b6185a5.png";